import { DefaultButton, IButtonStyles, Modal, Stack } from "@fluentui/react";
import * as React from "react";

const styleDefButton2: Partial<IButtonStyles> =
{
    root:
    {
        marginLeft: "0",
        marginTop: "1em",
        cursor: "pointer",
        background: "#CC214F",
        fontFamily: "Barlow",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#FFFFFF",
        borderRadius: "100px",
        padding: "0.5em 1.5em 0.5em 1.6em",
        borderStyle: "none",
    },
};

type Props =
{
    title?: string;
    body?: string | JSX.Element | JSX.Element[];
    btnSubmitText?: string;
    btnSubmitDisabled?: boolean;
    onSubmit?: any;
    onClose?: any;
    size?: "sm" | "lg" | "xl";
    showModal: boolean;
};

export const ErrorModal: React.FunctionComponent<Props> = (props: Props) =>
{
    const { body, title, showModal } = props;
    const [show, setShow] = React.useState(false);

    const handleClose = () =>
    {
        setShow(false);
        if(props.onClose !== undefined)
        {
            props.onClose();
        }
    };

    React.useEffect(() =>
    {
        setShow(showModal);
    }, [showModal]);

    const onSubmit = async () =>
    {
        handleClose();
        if(props.onSubmit !== undefined)
        {
            props.onSubmit();
        }
    };

    return(
        <React.Fragment>
            <Modal isOpen={showModal} onDismiss={handleClose} >
                <div style={{padding: "10px"}}>
                    <h3 className="text-center"><b>{title}</b></h3>
                </div>
                <div className="text-center">{body}</div>
                <Stack.Item style={{display: "flex", justifyContent: "center"}}>
                    <DefaultButton styles={styleDefButton2} onClick={onSubmit}>
                        Aceptar
                    </DefaultButton>
                </Stack.Item>
            </Modal>
        </React.Fragment>
    );
};